import { FormControlLabel, Grid, Switch, TextField } from "@mui/material";
import { isValidEmail } from "@vmosolutions/oc-interfaces";
import { EmailChipField } from "./EmailChipField";

export interface IGendecGlobalSettings {
  enabled: boolean;
  sendTo: string[];
  cc: string[];
  replyTo: string;
}

interface IGlobalSettingsProps {
  settings: IGendecGlobalSettings;
  onChange: (patch: Partial<IGendecGlobalSettings>) => void;
}

/**
 * Global GenDec settings: the enable toggle, the fallback recipient lists (sendTo /
 * cc, entered as free-text email chips via the shared `<EmailChipField>`), and the
 * reply-to address. Email format is checked via the shared `isValidEmail`; invalid
 * entries are flagged inline, and the parent blocks save via the same shared validator.
 */
export const GlobalSettings = (props: IGlobalSettingsProps): JSX.Element => {
  const { settings, onChange } = props;

  const replyToError = settings.replyTo !== "" && !isValidEmail(settings.replyTo);

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12}>
        <FormControlLabel
          control={<Switch checked={settings.enabled} onChange={(e) => onChange({ enabled: e.target.checked })} />}
          label="GenDec sending enabled"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <EmailChipField
          label="Send To (fallback recipients)"
          value={settings.sendTo}
          onChange={(next) => onChange({ sendTo: next })}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <EmailChipField label="CC" value={settings.cc} onChange={(next) => onChange({ cc: next })} />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          size="small"
          label="Reply To"
          value={settings.replyTo}
          onChange={(e) => onChange({ replyTo: e.target.value })}
          error={replyToError}
          helperText={replyToError ? "Not a valid email address" : " "}
        />
      </Grid>
    </Grid>
  );
};

export default GlobalSettings;
